import api from '@/api'

export default {
    //게시글 가져오기
    getWebpartArticles(searchSet: webpartBoard.WebpartQuerySet): Promise<webpartBoard.PagedData<webpartBoard.WebpartArticle>> {
        return api.post<webpartBoard.PagedData<webpartBoard.WebpartArticle>>({
            url: `/Portal/Article/api/getWebpartArticles`,
            data: searchSet
        });
    },
    //게시글과 해당 게시글에 매핑된 내용 필드 가져오기
    getWebpartArticlesWithContentField(searchSet: webpartBoard.WebpartQuerySet): Promise<webpartBoard.PagedData<webpartBoard.WebpartArticle>> {
        return api.post<webpartBoard.PagedData<webpartBoard.WebpartArticle>>({
            url: `/Portal/Article/api/getWebpartArticlesWithContentField`,
            data: searchSet
        });
    },

    /**
   * 메뉴 목록 조회(웹파트 대상게시판)
   * @returns 
   */
    GetBoardList(company:string){
        return api.get({
        url: `/Common/Menu/api/boardlist?comCode=${company}`,
        })
    },
}
